import ApiProductService from './ApiProductService';
import CacheHelper from '../helpers/CacheHelper';

let _selectedCategory = null;

function setSelectedCategory(category) {
  _selectedCategory = category;
}

function getSelectedCategory() {
  return _selectedCategory;
}

async function getCategories(shop) {
  const cacheKey = `${shop.shopId}-categories`;
  const cache = CacheHelper.get(cacheKey);
  if (cache) {
    return cache;
  }

  const data = await ApiProductService.getCategories(shop);

  CacheHelper.store(cacheKey, data);

  return data;
}

async function getCategory(shop, categoryId) {
  const cacheKey = `category-${shop.shopId}-${categoryId}`;
  const cache = CacheHelper.get(cacheKey);
  if (cache) {
    return cache;
  }

  const data = ApiProductService.getCategory(shop, categoryId);

  CacheHelper.store(cacheKey, data);

  return data;
}

async function getProducts(shop, category, searchKey) {
  const cacheKey = `${shop.shopId}-products-${category?.id ?? 'all'}-${searchKey}`;
  const cache = CacheHelper.get(cacheKey);
  if (cache) {
    return cache;
  }

  const data = await ApiProductService.getProducts(shop, category, searchKey);

  CacheHelper.store(cacheKey, data);

  return data;
}

async function getProduct(shop, productId) {
  const cacheKey = `product-${shop.shopId}-${productId}`;
  const cache = CacheHelper.get(cacheKey);
  if (cache) {
    return cache;
  }

  const data = await ApiProductService.getProduct(shop, productId);

  CacheHelper.store(cacheKey, data);

  return data;
}

const ProductService = {
  getProducts,
  getCategories,
  getCategory,
  getProduct,
  setSelectedCategory,
  getSelectedCategory,
};

export default ProductService;
